'use client';

import { Pie, PieChart } from 'recharts';

import { ChartConfig, ChartContainer, ChartTooltip, ChartTooltipContent } from '@/components/ui/chart';

type Props = {
  config: ChartConfig;
  dataKey: string;
  nameKey: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: any[];
};

// 🎑 View
export default function Chart({ config, data, dataKey, nameKey }: Props) {
  return (
    <ChartContainer config={config} className='mx-auto aspect-square max-h-[250px]'>
      <PieChart>
        <ChartTooltip cursor={false} content={<ChartTooltipContent hideLabel />} />
        <Pie data={data} dataKey={dataKey} nameKey={nameKey} innerRadius={70} cornerRadius={4} paddingAngle={4} />
      </PieChart>
    </ChartContainer>
  );
}
